var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M0,14.25V18H3.75L14.81,6.94,11.06,3.19ZM17.71,4a1,1,0,0,0,0-1.41L15.37.29A1,1,0,0,0,14,.29L12.13,2.12l3.75,3.75Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }